export default Object.freeze({
  MERCHANT: 'merchant',
  SUB_MERCHANT: 'sub_merchant',
  MASTER_MERCHANT: 'master_merchant',
});

